import { TFormFields } from '@/models/chat.model';
import { TUserDataFormValues } from '@/modules/Chat';
import { createContext, ReactNode, useContext } from "react";

export type TButton = {
  text: string;
  action: string;
};

export type TSocketContext = {
  messages: IMessage[],
  sendMessage: (message: string) => void,
  clearForm: () => void,
  formFields: TFormFields[],
  sendForm: (values: TUserDataFormValues) => void;
  setMessages: (value: (((prevState: IMessage[]) => IMessage[]) | IMessage[])) => void,
  buttons?: TButton[],
  isTyping: boolean
};

export interface IMessage {
  sender?: string;
  type?: string;
  message: ReactNode;
  date?: Date | string;
}

export const SocketContext = createContext<TSocketContext | null>(null);

export const useSocket = () => {
  const socket = useContext(SocketContext);

  if (!socket) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};
